var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoolEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6273 18.6273 24 12 24C5.37267 24 0 18.6273 0 12C0 5.37267 5.37267 0 12 0C18.6273 0 24 5.37267 24 12Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.826043 7.34534C0.986043 7.50467 1.78471 7.98334 1.94404 8.462C2.10404 8.94 2.42404 11.6513 3.38271 12.4493C4.37138 13.2707 8.10071 12.9653 8.81471 12.6093C10.4127 11.8127 10.6087 9.58867 10.8914 8.462C11.0507 7.824 12.0094 7.824 12.0094 7.824C12.0094 7.824 12.968 7.824 13.128 8.46134C13.4107 9.58867 13.608 11.8127 15.2047 12.6087C15.9194 12.9653 19.6487 13.2713 20.6387 12.45C21.596 11.652 21.9154 8.94067 22.0754 8.462C22.234 7.984 23.034 7.50534 23.1934 7.346C23.354 7.18667 23.354 6.54867 23.1934 6.38867C22.874 6.07 19.104 5.786 15.0447 6.22934C14.2347 6.318 13.9267 6.548 12.0087 6.548C10.092 6.548 9.78271 6.31734 8.97338 6.22934C4.91671 5.78534 1.14604 6.06934 0.826043 6.388C0.66671 6.54734 0.66671 7.186 0.826043 7.34534Z",
    fill: "#292F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2232 15.7527C18.1046 15.6453 17.9272 15.6387 17.7999 15.7333C17.7739 15.7527 15.1852 17.6667 11.9999 17.6667C8.82255 17.6667 6.22522 15.7527 6.19989 15.7333C6.07255 15.6387 5.89522 15.6467 5.77655 15.7527C5.65855 15.8593 5.63189 16.0353 5.71389 16.1713C5.79989 16.3147 7.85855 19.6667 11.9999 19.6667C16.1412 19.6667 18.2006 16.3147 18.2859 16.1713C18.3679 16.0347 18.3419 15.8593 18.2232 15.7527Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolEmoji);
export default __webpack_public_path__ + "static/media/cool-emoji.c9795827ac76e481c6e2a0930c19e44a.svg";
export { ForwardRef as ReactComponent };